import { render } from "./TicketActionCard.vue?vue&type=template&id=d9062238"
import script from "./TicketActionCard.vue?vue&type=script&lang=js"
export * from "./TicketActionCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__